import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ThemeModule } from "app/@theme/theme.module";
import { CargandoComponent } from "./cargando/cargando.component";
import { HasAnyFunctionDirective } from "./directives/has-any-function.directive";
import { HasFunctionDirective } from "./directives/has-function.directive";
import { HasNotFunctionDirective } from "./directives/has-not-function.directive";
import { SiniestroPrintComponent } from "./print/print-siniestro.component";

@NgModule({
  imports: [ThemeModule, FormsModule, CommonModule],
  declarations: [
    CargandoComponent,
    HasFunctionDirective,
    HasNotFunctionDirective,
    SiniestroPrintComponent,
    HasAnyFunctionDirective
  ],
  exports: [CargandoComponent, HasFunctionDirective, HasNotFunctionDirective, SiniestroPrintComponent, HasAnyFunctionDirective],
})
export class SharedModule {}
